var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-primary text-white text-bold text-h6 text-center",staticStyle:{"height":"100vh"}},[(_vm.waiting)?_c('span',[_vm._v(" Aguarde... ")]):_c('span',[_vm._v(" Autenticado com sucesso no Zoho CRM! ")])])}
var staticRenderFns = []

export { render, staticRenderFns }